import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/header_mobile.png'
import _imports_1 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-719a3eab"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mobile-container",
  ref: "pageRef"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, "Batch Approval"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-image",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "total" }
const _hoisted_4 = { class: "control-right" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Reject")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Approve")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "Approval Infomation")
], -1))
const _hoisted_8 = { class: "detail-list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "BU:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Batch Name:", -1))
const _hoisted_11 = { style: {"word-break":"break-all"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Submit Date:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Batch Total Budget:", -1))
const _hoisted_14 = {
  class: "c-p",
  id: "batch"
}
const _hoisted_15 = ["onTouchend"]
const _hoisted_16 = { style: {"padding-right":"5px"} }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Approval Path")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeOutlined = _resolveComponent("HomeOutlined")!
  const _component_m_button = _resolveComponent("m-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_m_segment = _resolveComponent("m-segment")!
  const _component_m_title = _resolveComponent("m-title")!
  const _component_ApproveSteps = _resolveComponent("ApproveSteps")!
  const _component_approval_modal = _resolveComponent("approval-modal")!
  const _component_m_info_modal = _resolveComponent("m-info-modal")!
  const _component_m_to_top = _resolveComponent("m-to-top")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      ref: "fixedRef",
      class: _normalizeClass([_ctx.isFixed ? 'is-fixed' : '', 'control', 'c-p'])
    }, [
      _createElementVNode("div", {
        class: "control-left",
        onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/mobile/management/pending/approval' })))
      }, [
        _createVNode(_component_HomeOutlined, { class: "home" }),
        _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(_ctx.$store.state.approve.pendingApproveCount) + ")", 1)
      ], 32),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_m_button, {
          class: "mr-24",
          onTap: _ctx.handleReject
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onTap"]),
        _createVNode(_component_m_button, {
          type: "primary",
          onTap: _ctx.handleApprove
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onTap"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isFixed ? 'fixed-after-item' : '', 'content'])
    }, [
      _hoisted_7,
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", null, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(_ctx.programTableData.buName), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.programTableData.batchName), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_12,
          _createElementVNode("span", null, _toDisplayString(_ctx.programTableData.packageSubmitTime.substr(0, 10)), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(_ctx.programTableData.totalBudget), 1)
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_a_table, {
        dataSource: _ctx.programTableData.programDtos,
        columns: _ctx.programColumn,
        rowKey: (record, index) => index,
        pagination: false
      }, {
        no: _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(++index), 1)
        ]),
        batchName: _withCtx(({ record }) => [
          _createElementVNode("a", {
            onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dealerTouchStart && _ctx.dealerTouchStart(...args))),
            onTouchend: ($event: any) => (_ctx.dealerToPage(record, $event))
          }, _toDisplayString(record.batchName), 41, _hoisted_15)
        ]),
        totalBudget: _withCtx(({ record }) => [
          _createElementVNode("span", _hoisted_16, _toDisplayString(record.totalBudget), 1)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "rowKey"])
    ]),
    _createVNode(_component_m_segment, { class: "mt-16 mb-16" }),
    _createVNode(_component_m_title, { class: "c-p mt-16 mb-16" }, {
      default: _withCtx(() => [
        _hoisted_17
      ]),
      _: 1
    }),
    _createVNode(_component_ApproveSteps, {
      data: _ctx.approveList.nodeList
    }, null, 8, ["data"]),
    _createVNode(_component_approval_modal, {
      visible: _ctx.approvalModalVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.approvalModalVisible) = $event)),
      type: _ctx.actionType,
      list: [_ctx.programTableData],
      onOnConfirm: _ctx.handleCommentsConfirm
    }, null, 8, ["visible", "type", "list", "onOnConfirm"]),
    _createVNode(_component_m_info_modal, {
      visible: _ctx.modalVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalVisible) = $event)),
      message: _ctx.modalMessage
    }, null, 8, ["visible", "message"]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_m_to_top, {
        "page-element": _ctx.pageRef,
        class: "color"
      }, null, 8, ["page-element"])
    ], 512), [
      [_vShow, _ctx.toTopShow]
    ])
  ], 512))
}